const orbit = "M -100 740 C 220 830 1410 350 1390 245 C 1380 200 1300 198 1250 220";
export default function HeroAtmosphere() {
  return <div className="ibt-space" aria-hidden="true">
    <span className="ibt-planet ibt-planet-near" /><span className="ibt-planet ibt-planet-far" />
    <svg className="ibt-orbit" viewBox="0 0 1440 900" preserveAspectRatio="none" focusable="false">
      <path className="ibt-orbit-line" pathLength="1000" d={orbit} />
      <path className="ibt-orbit-glow" pathLength="1000" d={orbit} />
      <path className="ibt-orbit-light" pathLength="1000" d={orbit} />
    </svg>
  </div>;
}
